/* Routes for the settings area (Area C: account). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [{ path: 'settings/*', lazy: page(() => import('./pages/SettingsPage')) }],
}
